const ShelfSkeleton = () => (
  <div className="space-y-4">
    <div className="h-7 w-48 bg-white/5 rounded-md" />
    <div className="flex gap-4 overflow-hidden">
      {[0, 1, 2, 3].map((i) => (
        <div
          key={i}
          className="shrink-0 w-[260px] lg:w-[300px] h-[260px] lg:h-[340px] rounded-xl bg-white/[0.03]"
        />
      ))}
    </div>
  </div>
);

export default ShelfSkeleton;
